import apiCalendarPlan from '@/api/calendar-plan'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createCalendarPlanStart: '[create calendar plan] Create calendar plan start',
  createCalendarPlanSuccess:
    '[create calendar plan] Create calendar plan success',
  createCalendarPlanFailure:
    '[create calendar plan] Create calendar plan failure',

  createCalendarPlanClearError:
    '[create calendar plan] Create calendar plan clear error',
}

export const actionTypes = {
  createCalendarPlan: '[create calendar plan] Create calendar plan',
}

const mutations = {
  [mutationTypes.createCalendarPlanStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createCalendarPlanSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createCalendarPlanFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.createCalendarPlanClearError](state) {
    state.error = null
  },
}

const actions = {
  [actionTypes.createCalendarPlan](context, {calendarPlan}) {
    context.commit(mutationTypes.createCalendarPlanStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .createCalendarPlan(calendarPlan)
        .then((response) => {
          context.commit(mutationTypes.createCalendarPlanSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createCalendarPlanFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
